import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { AlertTriangle, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Renders a slim amber banner across SMB pages when the master outreach
 * automation switch is OFF. Self-fetches the flag (cached client-side so
 * mounting it on multiple SMB pages costs at most one round-trip per session).
 */
let _cache = { value: null, ts: 0 };
const _CACHE_TTL_MS = 60000;

export const SmbOutreachAutomationBanner = () => {
  const [enabled, setEnabled] = useState(true);   // assume ON so banner hidden until we know

  useEffect(() => {
    const now = Date.now();
    if (_cache.value !== null && (now - _cache.ts) < _CACHE_TTL_MS) {
      setEnabled(_cache.value);
      return;
    }
    (async () => {
      try {
        const res = await api.get('/smb/outreach/automation/enabled');
        if (res.data.success) {
          const v = !!res.data.data?.enabled;
          _cache = { value: v, ts: now };
          setEnabled(v);
        }
      } catch { /* user may lack perms — silently leave banner hidden */ }
    })();
  }, []);

  if (enabled) return null;

  return (
    <div
      data-testid="smb-outreach-paused-banner"
      className="flex items-center justify-between gap-3 mb-4 px-4 py-2.5 rounded-md border border-amber-500/40 bg-amber-500/10 text-amber-200"
    >
      <div className="flex items-center gap-2 text-sm">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <p>
          <strong>Outreach automation paused.</strong> Manual sends still work — background
          campaigns, status-change triggers, and auto status promotion are disabled.
        </p>
      </div>
      <Link
        to="/settings"
        className="text-xs underline hover:no-underline shrink-0 inline-flex items-center gap-1"
      >
        Manage in Settings <ExternalLink className="h-3 w-3" />
      </Link>
    </div>
  );
};
